import { personalityReportActions } from 'affiny-core/modules/personalityReport/actions';
import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useDispatchGetPersonalityReport = () => {
  const dispatch = useDispatch();
  const myAccountId = useSelector(selectAccountId);

  useEffect(() => {
    dispatch(
      personalityReportActions.getPersonalityReport({ accountId: myAccountId })
    );
  }, []);
};

export const useDispatchGetPersonalityReportVision = () => {
  const dispatch = useDispatch();
  const myAccountId = useSelector(selectAccountId);

  useEffect(() => {
    dispatch(
      personalityReportActions.getPersonalityReportVision({
        accountId: myAccountId,
      })
    );
  }, []);

  return {};
};
